import { ReactNode, CSSProperties } from "react";
import { cn } from "@/lib/utils";

type Props = {
  children: ReactNode;
  className?: string;
  variant?: "gradient" | "onGradient";
  as?: "h2" | "h3";
};

/**
 * Canonical section heading. Renders purple→fuchsia gradient text by default.
 * Use variant="onGradient" for headings that sit on a gradient background
 * (e.g. the Final CTA section) — they render solid white instead.
 */
export const SectionHeading = ({
  children,
  className,
  variant = "gradient",
  as: Tag = "h2",
}: Props) => {
  const gradientStyle: CSSProperties =
    variant === "gradient"
      ? {
          background: "linear-gradient(to right, #7130A0, #ED1878)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          backgroundClip: "text",
        }
      : {};

  return (
    <Tag
      className={cn(
        "font-heading text-3xl md:text-4xl text-center",
        variant === "onGradient" && "text-white",
        className,
      )}
      style={gradientStyle}
    >
      {children}
    </Tag>
  );
};

export default SectionHeading;